/* eslint-disable @typescript-eslint/no-unused-vars */
/*
  Documentation
  * Fieldpass - https://github.mlbam.net/publishing-services/account-components/tree/main/src/components/FieldPass
  * Login Config - https://github.mlbam.net/publishing-services/account-components/tree/main/src/components/Login
  * Register config - https://github.mlbam.net/publishing-services/account-components/tree/main/src/components/Register
*/
import { MouseEvent, ChangeEvent } from 'react';
import {
  FieldPass as FieldPassComponent,
  FieldPassChangeReasons as FieldPassComponentChangeReasons,
  FieldPassCloseReasons as FieldPassComponentCloseReasons,
} from '@mlb/account-components';
import { Env, noop, User, LooseObject } from '@gif/shared-global';

export const FieldPassChangeReasons = FieldPassComponentChangeReasons;
export const FieldPassCloseReasons = FieldPassComponentCloseReasons;

export interface FieldPassChangeEvent extends ChangeEvent {
  reason: string;
  data: User;
}

export interface FieldPassCloseEvent extends MouseEvent {
  reason: string;
}

export interface FieldPassProps {
  isLoggedIn?: boolean;
  isOpen?: boolean;
  onChange?: (e: FieldPassChangeEvent) => void;
  onClose?: (e: FieldPassCloseEvent) => void;
  copyConfig?: LooseObject;
  env?: Env;
  lightboxProps?: LooseObject;
  loginConfig?: LooseObject;
  registerConfig?: LooseObject;
}

export const fieldPassEnvMap: LooseObject = {
  local: 'development',
  preview: 'development',
  dev: 'development',
  qa: 'qa',
  beta: 'beta',
  prod: 'production',
};

export function FieldPass(props: FieldPassProps) {
  const {
    isLoggedIn,
    isOpen,
    onChange = noop,
    onClose = noop,
    copyConfig,
    env = 'prod',
    lightboxProps,
    loginConfig,
    registerConfig,
  } = props;
  return (
    <FieldPassComponent
      isLoggedIn={isLoggedIn}
      isOpen={isOpen}
      onChange={onChange}
      onClose={onClose}
      copyConfig={copyConfig}
      env={fieldPassEnvMap[env]}
      lightboxProps={lightboxProps}
      loginConfig={loginConfig}
      registerConfig={registerConfig}
    />
  );
}

export default FieldPass;
